(() => {
  if (window.runorLazyVideoInitialized) return;
  window.runorLazyVideoInitialized = true;
  const selector = 'video[data-runor-lazy-autoplay="true"]';
  const initialized = new WeakSet();
  let observer;
  const activate = video => {
    if (video.dataset.runorVideoActivated === 'true') return;
    video.dataset.runorVideoActivated = 'true';
    observer?.unobserve(video);
    video.controls = video.dataset.runorControls === 'true';
    video.preload = 'metadata';
    video.autoplay = true;
    const playing = video.play();
    if (playing?.catch) playing.catch(() => { video.controls = true; });
  };
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) activate(entry.target); });
    }, { rootMargin: '200px 0px' });
  }
  const videosIn = root => {
    const videos = Array.from(root.querySelectorAll(selector));
    if (root.matches?.(selector)) videos.unshift(root);
    return videos;
  };
  const init = root => videosIn(root).forEach(video => {
    if (!initialized.has(video)) {
      initialized.add(video);
      // Original sources and manual controls remain available without this script.
      video.addEventListener('pointerdown', () => activate(video), { once: true });
      video.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') activate(video);
      });
    }
    if (video.dataset.runorVideoActivated === 'true') return;
    if (observer && !window.Shopify?.designMode) observer.observe(video);
    else activate(video);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    videosIn(event.target).forEach(video => observer?.unobserve(video));
  });
})();
